import { languageLookup } from 'shared/product/product-lookups';
import { SegmentFieldItem } from 'utils/segment-field-item.interface';


/* eslint-disable */
export const interchangesSegmentData: Array<SegmentFieldItem> = [
  {
    'field_map': 'brandLabel',
    'item_name': 'brand_label',
    'title': 'Brand Label',
    'hint_detail': 'Brand from the AAIA Brand Table',
    'hint_panel' : 'Select an existing brand or add a new one',
    'example': '',
    'sequence': 1,
    'show_more': true,
    'validation': {
      'pies65' : {
        maxlength: 60,
        message: 'Brand must be no more than 60 characters.'
      }
    },
    'lookup': null,
    'api_lookup': {
      'type': 'typeahead',
      'field_map': 'brandLabel',
      'item_name': 'title', // field to show in dropdown
      'lookup': 'brands',
    }
  },
  {
    'field_map': 'brandId',
    'item_name': 'brand_AAIAID',
    'title': 'Brand ID',
    'hint_detail': 'Brand',
    'hint_panel' : 'Select an existing brand or add a new one',
    'example': '',
    'sequence': 1,
    'show_more': true,
    'validation': {
      'pies65' : {
        maxlength: 60,
        message: 'Brand must be no more than 60 characters.'
      }
    },
    'lookup': null,
  },
  {
    'field_map': 'subBrandLabel',
    'item_name': 'sub_brand_label',
    'title': 'Sub Brand',
    'hint_detail': 'Sub Brand from the AAIA Brand Table',
    'hint_panel' : 'Select an existing Sub Brand or add a new one',
    'example': '',
    'sequence': 1,
    'show_more': true,
    'validation': {
      'pies65' : {
        maxlength: 60,
        message: 'Sub Brand must be no more than 60 characters.'
      }
    },
    'lookup': null,
  },
  {
    'field_map': 'subBrandId',
    'item_name': 'sub_brand_AAIAID',
    'title': 'Sub Brand',
    'hint_detail': 'Sub Brand',
    'hint_panel' : 'Select an existing Sub Brand or add a new one',
    'example': '',
    'sequence': 1,
    'show_more': true,
    'validation': {
      'pies65' : {
        maxlength: 60,
        message: 'Sub Brand must be no more than 60 characters.'
      }
    },
    'lookup': null,
    'api_lookup': {
      'type': 'list',
      'field_map': 'brandId',
      'lookup': 'sub-brands',
      'dataHandler': (data: any[]) => {
        data.unshift({
          option: '',
          title: '-',
        })
      },
    }
  },
  {
    'field_map': 'partNumber',
    'item_name': 'part_number',
    'title': 'Part no.',
    'hint_detail': 'Part number of interchange item.',
    'hint_panel' : 'Select an existing part number from this brand',
    'example': '',
    'sequence': 2,
    'show_more': true,
    'validation': {
      'pies65' : {
        minLength: 1,
        maxLength: 48,
        message: 'Part number must be no more than 48 characters.'
      }
    },
    'lookup': null
  },
  {
    'field_map': 'typeCode',
    'item_name': 'type_code',
    'title': 'Interchange type',
    'hint_detail': '[OEM] OEM part number [SUB] Substitute will interchange with other supplier product. [USER] User specified- code used when other\'s do not apply.',
    'hint_panel' : '[OEM] OEM part number [SUB] Substitute will interchange with other supplier product. [USER] User specified- enter a code when other\'s do not apply.',
    'example': 'Substitute',
    'sequence': 3,
    'show_more': true,
    'lookup': [
      {
        "option": "O",
        "title": "OEM"
      },
      {
        "option": "S",
        "title": "Substitute"
      },
      {
        "option": "U",
        "title": "User defined"
      },
    ]
  },
  {
    'field_map': 'qualityGradeLevel',
    'item_name': 'quality_grade_level',
    'title': 'Interchange quality',
    'hint_detail': 'Interchange quality of item.',
    'hint_panel' : 'Is this interchange product OEM, premium or standard?',
    'example': 'Standard',
    'sequence': 4,
    'show_more': true,
    'lookup': [
      {
        "option": "P",
        "title": "Premium"
      },
      {
        "option": "O",
        "title": "OEM"
      },
      {
        "option": "S",
        "title": "Standard"
      }
    ]
  },
  {
    'field_map': 'languageCode',
    'item_name': 'language',
    'title': 'Language',
    'hint_detail': 'Language in which this description is written.',
    'hint_panel' : 'Choose the language which this description is written.',
    'example': 'English',
    'sequence': 5,
    'show_more': true,
    'lookup': languageLookup,
  },
  {
    'field_map': 'interchangeNotes',
    'item_name': 'interchange_notes',
    'title': 'Interchange notes',
    'hint_detail': 'Notes for this Interchange, up to 240 characters.',
    'hint_panel' : 'Up to 240 characters. Enter notes about this interchange.',
    'example': 'This is a Standard Substitute for the item.',
    'sequence': 6,
    'show_more': false,
    'validation': {
      'pies65' : {
        minLength: 1,
        maxLength: 240,
        message: 'Interchange notes must be no more than 240 characters.'
      }
    },
    'lookup': null
  },
  {
    'field_map': 'internalNotes',
    'item_name': 'internal_notes',
    'title': 'Internal notes',
    'hint_detail': 'Internal notes for this interchange.',
    'hint_panel' : 'Internal notes for this interchange.',
    'example': 'Notes for the internal team about this interchange.',
    'sequence': 7,
    'show_more': false,
    'validation': {
      'pies65' : {
        minLength: 1,
        maxLength: 240,
        message: 'Internal notes must be no more than 240 characters.'
      }
    },
    'lookup': null
  }
];
/* eslint-enable */
